import { Link } from "react-router-dom";

import { Button } from "../components/ui/button";

/**
 * Placeholder landing for the unauthenticated portal. T2.2 will replace
 * this with the real signup CTA + marketing copy. Keeping the layout
 * minimal so we can verify the design tokens render correctly in dev.
 */
export function HomePage(): JSX.Element {
  return (
    <main className="mx-auto flex min-h-full max-w-3xl flex-col items-center justify-center gap-8 px-6 py-12 text-center">
      <h1 className="text-4xl font-bold tracking-tight text-neutral-900">
        Email Builder Portal
      </h1>
      <p className="max-w-xl text-lg text-neutral-600">
        Manage templates, team, billing, and integrations. Phase 2 scaffold —
        auth flows, dashboard, and CRUD UIs land in T2.2 onward.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Link to="/signup">
          <Button variant="primary" size="lg">
            Get started
          </Button>
        </Link>
        <Link to="/login">
          <Button variant="outline" size="lg">
            Sign in
          </Button>
        </Link>
      </div>
    </main>
  );
}
